import {
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaYoutube,
} from "react-icons/fa";
import { MdEmail, MdLocationOn } from "react-icons/md";
import img1 from "../../Assets/Images/FooterImages/Frame_1.webp";
import img10 from "../../Assets/Images/FooterImages/Frame_10.webp";
import img11 from "../../Assets/Images/FooterImages/Frame_11.webp";
import img12 from "../../Assets/Images/FooterImages/Frame_12.webp";
import img13 from "../../Assets/Images/FooterImages/Frame_13.webp";
import img14 from "../../Assets/Images/FooterImages/Frame_14.webp";
import img15 from "../../Assets/Images/FooterImages/Frame_15.webp";
import img16 from "../../Assets/Images/FooterImages/Frame_16.webp";
import img17 from "../../Assets/Images/FooterImages/Frame_17.webp";
import img19 from "../../Assets/Images/FooterImages/Frame_19.webp";
import img2 from "../../Assets/Images/FooterImages/Frame_2.webp";
import img20 from "../../Assets/Images/FooterImages/Frame_20.webp";
import img21 from "../../Assets/Images/FooterImages/Frame_21.webp";
import img22 from "../../Assets/Images/FooterImages/Frame_22.webp";
import img3 from "../../Assets/Images/FooterImages/Frame_3.webp";
import img4 from "../../Assets/Images/FooterImages/Frame_4.webp";
import img5 from "../../Assets/Images/FooterImages/Frame_5.webp";
import img6 from "../../Assets/Images/FooterImages/Frame_6.webp";
import img7 from "../../Assets/Images/FooterImages/Frame_7.webp";
import img9 from "../../Assets/Images/FooterImages/Frame_9.webp";
import logo from "../../Assets/Images/FooterImages/logo.webp";
import { Link } from "react-router-dom";

const footerImages = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img19,
  img20,
  img21,
  img22,
];

const Footer = () => {
  return (
    <footer className="bg-[#F7F1EC] pb-20 md:pb-0 px-4 sm:px-8 md:px-10 lg:px-12 mx-auto ">
      {/* Desktop view */}
      <div className="hidden lg:block">
        <div className="mx-auto pt-16 overflow-hidden">
          <div className="flex gap-4 animate-footer-scroll w-max">
            {[...footerImages, ...footerImages].map((img, i) => (
              <div
                key={i}
                className="rounded-xl w-32 h-20 p-3 bg-white flex-shrink-0"
              >
                <img key={i} src={img} alt="img" className="w-full h-full" />
              </div>
            ))}
          </div>
        </div>

        {/* MAIN FOOTER CONTENT */}
        <div className="max-w-7xl mx-auto pt-20 px-0 grid grid-cols-1 lg:grid-cols-3 gap-16 items-start text-[#2E2E2E]">
          {/* LEFT – CONTACT */}
          <div>
            <h3 className="font-philosopher text-3xl mb-6 text-[#000000]">
              Contact
            </h3>

            <div className="space-y-6 text-sm text-[#2F2F2F]">
              {/* Phone */}
              <div className="flex flex-col items-start">
                <div className="flex items-center gap-3">
                  <FaPhoneAlt className="text-[#C28B61]" />
                  <span>+91-83388 22566</span>
                </div>
                <div className="w-64 h-[1px] bg-[#D6D6D6] mt-3"></div>
              </div>

              {/* Email */}
              <div className="flex flex-col items-start">
                <div className="flex items-center gap-3">
                  <MdEmail className="text-[#C28B61]" />
                  <span>sakhibyshweta@gmail.com</span>
                </div>
                <div className="w-64 h-[1px] bg-[#D6D6D6] mt-3"></div>
              </div>

              {/* Address */}
              <div className="flex items-start gap-3 max-w-xs">
                <MdLocationOn className="text-[#C28B61] mt-1" />
                {/* <span>Ashok Nagar, Bhubaneswar, Odisha</span> */}
                {/* <span>Bhubaneswar - Cuttack - Rourkela</span> */}
                <span>PLOT - 12, east, Ashok Nagar, Bhubaneswar, Odisha 751009</span>
              </div>
            </div>
          </div>

          {/* CENTER – LOGO & TEXT */}
          <div className="text-center -translate-y-8">
            <img src={logo} alt="logo" className="mx-auto mb-6 w-28" />

            <p className="text-sm text-[#2F2F2F] leading-relaxed max-w-sm mx-auto">
              We are your trusted beauty destination, offering premium hair,
              skin, and grooming services. Our expert stylists and therapists
              are dedicated to enhancing your natural beauty with care and
              creativity.
            </p>

            <div className="flex justify-center gap-6 mt-6 text-[#C28B61]">
              <Link to={'https://www.facebook.com/p/SAKHI-HOME-SALON-61583587180929/'} target="_blank"><FaFacebookF className="cursor-pointer hover:opacity-70" /></Link>
              <Link to={'https://www.instagram.com/sakhi_bhubaneswar/'} target="_blank"><FaInstagram className="cursor-pointer hover:opacity-70" /></Link>
              {/* <Link to={'https://www.youtube.com/@sakhibhubaneswar'} target="_blank"><FaYoutube className="cursor-pointer hover:opacity-70" /></Link> */}
            </div>
          </div>

          {/* RIGHT – OPENING HOURS */}
          <div className="text-right">
            <h3 className="font-philosopher text-3xl mb-6 text-[#000000]">
              Opening Hours
            </h3>

            <div className="space-y-6 text-sm text-[#2F2F2F]">
              {/* Row 1 */}
              <div className="flex flex-col items-end">
                <div className="flex gap-6">
                  <span>Mon - Wed</span>
                  <span>10AM - 8PM</span>
                </div>
                <div className="w-64 h-[1px] bg-[#D6D6D6] mt-3"></div>
              </div>

              {/* Row 2 */}
              <div className="flex flex-col items-end">
                <div className="flex gap-6">
                  <span>Thu - Sat</span>
                  <span>10AM - 10PM</span>
                </div>
                <div className="w-64 h-[1px] bg-[#D6D6D6] mt-3"></div>
              </div>

              {/* Row 3 */}
              <div className="flex flex-col items-end">
                <div className="flex gap-6">
                  <span>Sunday</span>
                  <span>Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      {/* Mobile View */}
      <div className="lg:hidden py-4 ">
        <div className="text-center mb-6">
          <img src={logo} alt="logo" className="mx-auto mb-6 w-16 sm:w-28" />

          <p className="text-sm text-[#2F2F2F] leading-relaxed max-w-sm mx-auto">
            We are your trusted beauty destination, offering premium hair, skin,
            and grooming services. Our expert stylists and therapists are
            dedicated to enhancing your natural beauty with care and creativity.
          </p>
          <div className="flex justify-center gap-6 mt-6 text-[#C28B61]">
            <Link to={'https://www.facebook.com/p/SAKHI-HOME-SALON-61583587180929/'} target="_blank"><FaFacebookF className="cursor-pointer hover:opacity-70" /></Link>
            <Link to={'https://www.instagram.com/sakhi_bhubaneswar/'} target="_blank"><FaInstagram className="cursor-pointer hover:opacity-70" /></Link>
            {/* <Link to={'https://www.youtube.com/@sakhibhubaneswar'} target="_blank"><FaYoutube className="cursor-pointer hover:opacity-70" /></Link> */}
          </div>
        </div>
        <div className="overflow-hidden">
          <div className="flex gap-4 animate-footer-scroll w-max">
            {" "}
            {[...footerImages, ...footerImages]?.map((img, i) => (
              <div
                key={i}
                className="rounded-lg sm:rounded-2xl object-cover h-16 sm:h-20 px-2 py-1 bg-white flex-shrink-0"
              >
                <img src={img} alt="img" className="w-full h-full" />
              </div>
            ))}
          </div>
        </div>

        {/* CONTACT */}
        <div className="mt-8">
          <h3 className="font-philosopher text-xl sm:text-3xl mb-6 text-[#000000]">
            Contact
          </h3>

          <div className="space-y-3 sm:space-y-6 text-sm text-[#2F2F2F] max-w-full ">
            {/* Phone */}
            <div>
              <div className="flex items-center gap-3">
                <FaPhoneAlt className="text-[#C28B61]" />
                <span>+91-83388 22566</span>
              </div>
              <div className="w-full h-[1px] bg-[#D6D6D6] mt-3"></div>
            </div>

            {/* Email */}
            <div>
              <div className="flex items-center gap-3">
                <MdEmail className="text-[#C28B61]" />
                <span>sakhibyshweta@gmail.com</span>
              </div>
              <div className="w-full h-[1px] bg-[#D6D6D6] mt-3"></div>
            </div>

            {/* Address */}
            <div className="flex items-start gap-3">
              <MdLocationOn className="text-[#C28B61] mt-1" />
              <span>PLOT - 12, east, Ashok Nagar, Bhubaneswar, Odisha 751009</span>
              {/* <span>Bhubaneswar - Cuttack - Rourkela</span> */}
            </div>
          </div>
        </div>

        {/* OPENING HOURS */}
        <div className="mt-10">
          <h3 className="font-philosopher text-xl sm:text-3xl mb-6 text-[#000000]">
            Opening Hours
          </h3>

          <div className="space-y-3 sm:space-y-6 text-sm text-[#2F2F2F] max-w-full">
            {/* Row 1 */}
            <div>
              <div className="flex justify-between">
                <span>Mon - Wed</span>
                <span>10AM - 8PM</span>
              </div>
              <div className="w-full h-[1px] bg-[#D6D6D6] mt-3"></div>
            </div>

            {/* Row 2 */}
            <div>
              <div className="flex justify-between">
                <span>Thu - Sat</span>
                <span>10AM - 10PM</span>
              </div>
              <div className="w-full h-[1px] bg-[#D6D6D6] mt-3"></div>
            </div>

            {/* Row 3 */}
            <div className="flex justify-between">
              <span>Sunday</span>
              <span>Closed</span>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER BOTTOM BAR */}
      <div className="mt-4">
        {/* Shiny Divider */}
        <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-accentTextColor to-transparent opacity-70"></div>

        {/* Bottom Bar */}
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#2F2F2F]">
          <p>© {new Date().getFullYear()} Sakhi Salon. All rights reserved.</p>

          <p>
            Designed & Developed by{" "}
            <a
              href="https://www.webbocket.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-accentTextColor font-medium hover:underline hover:opacity-80 transition"
            >
              Webbocket
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
